export default __webpack_public_path__ + "static/media/GN.fcc7731e.svg";